import React from 'react';

const ArtistContentMainName = (props:any) => {
    const artistName = props.artistName;
    const link = props.link;

    return (
        <div className={'text-2xl font-bold my-2'} data-grid-artist-name="true">
            {
                link !== '' && <a className={'no-underline text-gray-700'} href={link} dangerouslySetInnerHTML={{__html:artistName}}/>
            }
            { link === '' && <span dangerouslySetInnerHTML={{__html:artistName}}/>}
        </div>
    )

}

export default ArtistContentMainName;